import React from 'react'
import type { CardProps as MuiCardProps } from '@material-ui/core/Card'
import MuiCard from '@material-ui/core/Card'

export type CardProps = MuiCardProps

const Card = React.forwardRef<HTMLDivElement, CardProps>(function Card(props, ref) {
  return <MuiCard ref={ref} {...props} />
})

export default Card
